const changeFileExtension = (file, extension) => {
  const splitFilename = file.split('.')
  const extensionIndex = splitFilename.length - 1
  splitFilename[extensionIndex] = extension
  return splitFilename.join('.')
}

export default changeFileExtension
